var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('p',[_vm._v("\n      All Rights Reserved.\n      "),_c('br'),_vm._v("Powered by JD SPORTS FASHION PLC\n    ")])])])
}]

export { render, staticRenderFns }